function getDataLayer() {
	window.dataLayer = window.dataLayer || [];
	return window.dataLayer;
}

export function sendData(combinedObject) {
	// In beide DataLayer pushen für Kompatibilität während der Migration
	const dataLayer = getDataLayer();
	dataLayer.push(combinedObject);
	console.debug("dataLayer", combinedObject);
	sendtoLegacyNewDataLayer(combinedObject);
}

function sendtoLegacyNewDataLayer(combinedObject) {
	// Add unique event ID to the combined object
	const objectWithEventId = {
		...combinedObject,
		datalayerEventId: generateUniqueEventId()
	};

	const analyticsContainer = window.newDataLayer = window.newDataLayer || [];
	analyticsContainer.push(objectWithEventId);

	// console.debug("dtmApi (legacy)", objectWithEventId);
}

/**
 * Generates a unique event ID using timestamp and random number
 * @returns {string} Unique event ID in format: timestamp_randomNumber
 */
function generateUniqueEventId() {
	const timestamp = Date.now();
	const randomNumber = Math.floor(Math.random() * 1000000);
	return `${timestamp}.${randomNumber}`;
}